/*
|--------------------------------------------------------------------------
| Views: Featured Single
|--------------------------------------------------------------------------
*/

/**
 * Featured Single
 * @namespace
 */
__gh__webApp.views.featuredSingle = {
	"callbacks": function(){
		__gh__webApp.utilities.parallax.init();
	},

	"getSubView": function(bucket){
		var	items 			= (bucket.items.main) ? bucket.items.main : {},
			validateItem	=__gh__webApp.data.itemValidator,
			viewFolder		= "buckets/featuredSingle",
			killBucket		= false;


		//Verify first item has an image
		var featuredImagePosition = validateItem({"data":items.slice(0,1),"required":1,"validationMethod":"hasImage"});
		if (featuredImagePosition !== false){
			bucket.view.name = viewFolder + "/default";
			return bucket;
		}

		return killBucket;

	}
};
